export class StatBuilder<K>
{
    readonly stat = new Map<K, number>();
    
    inc(...keys: K[])
    {
        keys.forEach(k => this.incOne(k));
    }

    private incOne(key: K)
    {
        this.stat.set(key, (this.stat.get(key) || 0) + 1);
    }
}

export const topKeys = <K>(stat: Map<K, number>, n: number): K[] => {
    return top(stat, n).map(kv => kv[0]);    
}

export const top = <K>(stat: Map<K, number>,n: number): [K, number][] => {
    if(!Number.isInteger(n))
        throw new Error('n has to be an integer number');

    const entries = [...stat];
    return entries.sort((a, b) => a[1] - b[1])
        .slice(0, n);
}


// WEBPACK FOOTER //
// ./src/utils/StatBuilder.ts